import { render, staticRenderFns } from "./PokerPlayer.vue?vue&type=template&id=a2f7150a&scoped=true&"
import script from "./PokerPlayer.vue?vue&type=script&lang=js&"
export * from "./PokerPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PokerPlayer.vue?vue&type=style&index=0&id=a2f7150a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f7150a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
